// extracted by mini-css-extract-plugin
export default {"fields":"kEITmn","time":"PTzAp3","mobile":"Qko03O"};